import { newToolFilterOAuthMcp } from "../oauth.ts";

export const jamMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://framerusercontent.com/images/PJzGWvCk8HH9Ho4kUWVsQtYI.png",
  url: "https://mcp.jam.dev/mcp",
  label: "Jam",
});
